/* Project Import will be here */
import { post, IRequest } from "../index";
import { ISalesReturnHistoryDetailsParams } from "models/salesReturnModels";
import { IOrderHistoryFilterParams } from "models/orderModels";
/* Project Import will be here */

/* Get the sales return history to list in the history list page */
export const getSalesReturnHistoryListApi = (data: IOrderHistoryFilterParams) => {
    const request: IRequest = { subUrl: `/SalesReturn/ReturnView`, data };
    return post(request);
};

/* Get the sales return history details */
export const getSalesReturnHistoryDetailsApi = (data: ISalesReturnHistoryDetailsParams) => {
    const request: IRequest = { subUrl: `/SalesReturn/ReturnViewDetails`, data };
    return post(request);
};